import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import AutoCompleteSelect from '~/components/AutoCompleteSelect';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/newInput';
import { BankData as BD } from '~/services/banknow/types';
import Endpoints from '~/services/endpoints';
import { ApiMethod, httpRequest } from '~/services/httpRequest';

const CPF_LENGTH = 11;
const CNPJ_LENGTH = 14;

function isValidDocumentLength(document?: any): boolean {
  if (!document) return false;
  return document.length === CPF_LENGTH || document.length === CNPJ_LENGTH;
}

const BankData = forwardRef(
  (
    {
      defaultValues,
      onChange,
    }: {
      defaultValues: BD;
      onChange: (values: BD) => void;
    },
    ref,
  ) => {
    const [values, setValues] = useState(defaultValues);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    useEffect(() => {
      onChange(values);
    }, [values]);

    const getNestedValue = (obj, path) => {
      return path.reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
        obj,
      );
    };

    const handleErrors = () => {
      const fieldsToCheck = [
        'accountHolder.holderName',
        'bank',
        'account',
        'accountHolder.cpfCnpj',
        'agency',
        'digit',
      ];

      const errors = {};

      fieldsToCheck.forEach((field) => {
        const value = getNestedValue(values, field.split('.'));
        console.log('VALUE AGREEMENT', value);
        if (
          value === undefined ||
          value === null ||
          value === '' ||
          value === '' ||
          value.length === 0
        ) {
          errors[field] = 'Campo obrigatório';
        }
      });

        const document = values?.accountHolder?.cpfCnpj.unmasked;

        if (!isValidDocumentLength(document)) {
          errors['accountHolder.cpfCnpj'] = 'CPF/CNPJ inválido';
        }

      console.log('Errors bank', errors);

      setErrors(errors);

      return Object.keys(errors).length > 0;
    };

    const updateNestedValue = (obj, path, value) => {
      if (!path.length) return value;
      const [key, ...rest] = path;
      return { ...obj, [key]: updateNestedValue(obj[key] || {}, rest, value) };
    };
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      setValues((prev) => updateNestedValue(prev, name.split('.'), value));
    };
    const [banks, setBanks] = useState([]);
    useEffect(() => {
      const getBanks = async () => {
        const response = await httpRequest<{
          banks: { code: number; fullName: string; ispb: string }[];
        }>({
          url: Endpoints.companies.getBanks,
          method: ApiMethod.POST,
          body: { fullName: '' },
        });
        setBanks(response.data?.banks);
      };
      getBanks();
    }, []);

    useImperativeHandle(ref, () => ({
      handleErrors,
    }));

    return (
      <ContainerFlex gap={12} row space marginTop={20}>
        <ContainerFlex>
          <Input
            name="accountHolder.holderName"
            label="Nome Titular"
            value={values?.accountHolder?.holderName}
            onChange={handleChange}
            errorMessage={errors['accountHolder.holderName']}
          />
          <AutoCompleteSelect
            name="bank"
            label="Banco"
            value={values?.bankName}
            onChange={(op) => {
              console.log(op);
              setValues((prev) => ({
                ...prev,
                bank: op.ispb,
                code: op.id ? +op.id : 0,
                bankName: op.value,
              }));
            }}
            options={banks?.map((b) => ({
              id: b.code,
              value: b.fullName,
              ispb: b.ispb,
            }))}
            errorMessage={errors['bank']}
          />
          <Input
            name="account"
            label="Conta"
            value={values?.account}
            onChange={handleChange}
            errorMessage={errors['account']}
          />
        </ContainerFlex>
        <ContainerFlex>
          <Input
            name="accountHolder.cpfCnpj"
            label="CPF/CNPJ Titular"
            mask={MaskTypes.CPF_CNPJ}
            value={values?.accountHolder?.cpfCnpj?.masked}
            onChange={handleChange}
            errorMessage={errors['accountHolder.cpfCnpj']}
          />

          <Input
            name="agency"
            label="Agência"
            value={values?.agency}
            onChange={handleChange}
            errorMessage={errors['agency']}
          />
          <Input
            name="digit"
            label="Dígito"
            value={values?.digit}
            onChange={handleChange}
            errorMessage={errors['digit']}
          />
        </ContainerFlex>
      </ContainerFlex>
    );
  },
);

export default BankData;
